import PropTypes from 'prop-types';
import React, { cloneElement, useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import search from 'utils/search';

import PersonCardEmpty from '../personCardEmpty';
import PersonCardNoResult from '../personCardNoResult';
import PersonSearchForm from '../personSearchForm';

const StyledPersonSearchForm = styled(PersonSearchForm)`
  margin-bottom: 20px;
`;

const StyledPersonCardEmpty = styled(PersonCardEmpty)`
  margin-bottom: 20px;
`;

const StyledPersonCardNoResult = styled(PersonCardNoResult)`
  margin-bottom: 20px;
`;

const PeopleInBookPanel = ({ panel, people, personGroup, includeCitations = true }) => {
  const [searchText, setSearchText] = useState('');

  const foundPeople = useMemo(
    () => search(people, searchText, { stringifyItem: person => person.name }),
    [people, searchText],
  );

  const handleChange = useCallback(value => setSearchText(value), []);

  const handleReset = useCallback(() => setSearchText(''), []);

  const infoNode = useMemo(() => {
    // When there are no loaded people, there is no way to load more.
    if (people.length === 0) {
      return <StyledPersonCardEmpty />;
    }
    // All people are filtered out by search.
    if (foundPeople.length === 0) {
      return <StyledPersonCardNoResult onReset={handleReset} />;
    }
    // People are displayed, no need to show info.
    return null;
  }, [foundPeople.length, handleReset, people.length]);

  return (
    <>
      <StyledPersonSearchForm onChange={handleChange} value={searchText} />
      {infoNode}
      {cloneElement(panel, { people: foundPeople, allPeople: people, personGroup, includeCitations })}
    </>
  );
};

PeopleInBookPanel.defaultProps = {
  people: [],
};

PeopleInBookPanel.propTypes = {
  panel: PropTypes.node.isRequired,
  people: PropTypes.arrayOf(PropTypes.object),
  personGroup: PropTypes.object.isRequired,
  includeCitations: PropTypes.bool,
};

export default PeopleInBookPanel;
